import * as Rx from 'rxjs';
import { finalize, map } from 'rxjs/operators';

import apiService from '../api';

import type { ApiService } from '../api';

interface IApiKey {
  api_key?: string;
  api_key_last_digits?: string;
  api_key_generated_at: string;
  deprecated_api_key?: string;
}

interface ISecret {
  origin_secret: string;
  origin_secret_generated_at: string;
}

export class ConfigAPIService {
  private loadingApiKey$ = new Rx.BehaviorSubject<boolean>(false);
  private apiKey$ = new Rx.ReplaySubject<IApiKey>(1);
  private loadingOriginKey$ = new Rx.BehaviorSubject<boolean>(false);
  private secretKey$ = new Rx.ReplaySubject<ISecret>(1);

  constructor(private apiService: ApiService) {}

  public isLoadingApiKey = () => this.loadingApiKey$;
  public isLoadingOriginKey = () => this.loadingOriginKey$;

  public getApiKey = () => {
    return this.apiKey$;
  };

  public getOriginKey = () => {
    return this.secretKey$;
  };

  public loadApiKey = () => {
    this.loadingApiKey$.next(true);
    return this.apiService.get('/config/apikey', {}).pipe(
      map((res) => this.apiKey$.next(res.data)),
      finalize(() => this.loadingApiKey$.next(false))
    );
  };

  public loadOriginKey = () => {
    this.loadingOriginKey$.next(true);
    return this.apiService.get('/config/origin-secret', {}).pipe(
      map((res) => this.secretKey$.next(res.data)),
      finalize(() => this.loadingOriginKey$.next(false))
    );
  };

  public updateApiKey = () => {
    this.loadingApiKey$.next(true);
    return this.apiService.put('/config/apikey', {}).pipe(
      map((res) => this.apiKey$.next(res.data)),
      finalize(() => this.loadingApiKey$.next(false))
    );
  };

  public updateOriginKey = () => {
    this.loadingOriginKey$.next(true);
    return this.apiService.put('/config/origin-secret', {}).pipe(
      map((res) => this.secretKey$.next(res.data)),
      finalize(() => this.loadingOriginKey$.next(false))
    );
  };
}

const configAPIService = new ConfigAPIService(apiService);
export default configAPIService;
